import { z } from 'zod';

const UserSchema = z.object({
  fresh: z.boolean(),
  iat: z.number(),
  jti: z.string(),
  nbf: z.number(),
  type: z.string(),
  sub: z.string(),
  exp: z.number(),
  email: z.string(),
  purpose: z.string(),
  phoneNumber: z.string().nullable(),
  roles: z.array(z.string()),
  companyName: z.string(),
  applicationId: z.string().optional().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  apiKey: z.string().nullable(),
  fmSdkKey: z.string().nullable(),
  fmApiKey: z.string().nullable(),
  isFleetTncOdnc: z.boolean(),
  securityId: z.string().optional().nullable(),
  subaccountId: z.string().optional().nullable(),
  sdkKey: z.string().nullable(),
  domain: z.string().url(),
  isFairmaticApproved: z.boolean().optional().nullable(),
  isFairmaticAppEnabled: z.boolean().optional().nullable(),
  distanceUnit: z.enum(['kms', 'miles']),
  flagsEnabled: z.array(z.string()),
  trackingId: z.string(),
  insuranceCarrierName: z.string().nullable(),
  redirectPasswordChange: z.boolean(),
});

export default UserSchema;
